// removed by extract-text-webpack-plugin
module.exports = {"root":"ReviewForm__root__3gaIa","error":"ReviewForm__error__kFImJ","errorPlaceholder":"ReviewForm__errorPlaceholder__e-QnR","reviewRating":"ReviewForm__reviewRating__PDu4G","reviewContent":"ReviewForm__reviewContent__3LzbK","submitButton":"ReviewForm__submitButton__opTfZ"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/ReviewForm/ReviewForm.css
// module id = 1734
// module chunks = 0